module.exports = __webpack_public_path__ + "static/HEAD_SHOT-cc499fe406ccee20e6abd9f9f64c9321.png";